import styled from 'styled-components';
import {
  Body,
  H3,
  Overline,
  CircledNumber as DefaultCircledNumber,
} from 'components/Typography';
import addAlpha from 'utils/addAlpha';
import {
  FiArrowDown as DefaultArrowDown,
  FiArrowUp as DefaultArrowUp,
} from 'react-icons/fi';
import DefaultDatesSelector from 'components/Form/WeekRangePicker';

// TODO: TFR-44 move to container group or do not export
export const Container = styled.div`
  width: 100%;
  height: auto;
  padding: 0;
  margin-bottom: 6.1875rem;
`;

// TODO: TFR-44 move to container group
export const TwoColumns = styled.div`
  display: grid;
  grid-template-columns: 1.7fr 1fr;
  grid-gap: 2rem;
  margin-bottom: 1.875rem;
`;

// TODO: TFR-44 move to container group
export const TwoRows = styled.div``;

// TODO: TFR-44 move to container group
export const Section = styled.div`
  :not(:last-child) {
    margin-bottom: 2rem;
  }
`;

// TODO: TFR-45:Title make unique name or do not export
export const Title = styled(H3)`
  margin-bottom: 1rem;
`;

// TODO: TFR-49 split components into two or more different logical components
export const AllItemsCard = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  width: 100%;
  border-radius: 1rem;
  padding: 2.125rem;
`;

// TODO: TFR-44 move to container group
export const Row = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  grid-gap: 2rem;
  text-align: right;
  :first-child {
    text-align: left;
  }
  :not(:last-child):not(:first-child) {
    margin-bottom: 1.3125rem;
  }
`;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const Header = styled(Row)``;

export const CaptionWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const CaptionButton = styled.button`
  background: none;
  cursor: pointer;
  border: none;
`;

export const Caption = styled(Overline)`
  display: inline-block;
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.6)};
  letter-spacing: 0.1em;
  font-weight: 600;
  margin-bottom: 1.25rem;
  text-align: right;
  :first-child {
    margin-left: 2.5rem;
    text-align: left;
  }
`;

export const ArrowDown = styled(DefaultArrowDown)`
  color: ${({ theme }) => theme.colors.navyGreen};
  margin-right: 0.5rem;
`;

export const ArrowUp = styled(DefaultArrowUp)`
  color: ${({ theme }) => theme.colors.navyGreen};
  margin-right: 0.5rem;
`;

// TODO: TFR-45:Name make unique name or do not export
export const Name = styled(Body)`
  font-weight: 600;
`;

export const Item = styled.div`
  display: flex;
  justify-content: left;
  :not(:last-child) {
    margin-bottom: 1.3125rem;
  }
  ${Name} {
    margin-left: 0.75rem;
  }
`;

export const NameWrapper = styled.div`
  display: flex;
  ${Name} {
    margin-left: 1.5rem;
  }
`;

export const Number = styled(Body)`
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.8)};
  font-variant-numeric: tabular-nums;
`;

export const Position = styled(Number)`
  font-size: 0.9375rem;
  width: 1.125rem;
  text-align: right;
`;

export const CircledNumber = styled(DefaultCircledNumber)``;

export const RatingsCard = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  width: 100%;
  border-radius: 1rem;
  padding: 2.1875rem 2rem;
`;

export const DatesSelector = styled(DefaultDatesSelector)``;

export const PickerContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
`;

export const DateCaption = styled(H3)`
  margin-right: 1.5rem;
`;
